import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { ContractTemplateEffect } from "./effect";
import { ContractTemplateReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([ContractTemplateEffect]),
        StoreModule.forFeature('ContractTemplate', ContractTemplateReducer)
    ]
})

export class ContractTemplateStoreModule { }

export const contractTemplateList = (store: any) => store && store.ContractTemplate && store.ContractTemplate.contractTemplateList;
export const contractTemplateById = (store: any) => store && store.ContractTemplate && store.ContractTemplate.contractTemplateById;
export const addContractTemplateResponse = (store: any) => store && store.ContractTemplate && store.ContractTemplate.addContractTemplateResponse;
export const updateContractTemplateResponse = (store: any) => store && store.ContractTemplate && store.ContractTemplate.updateContractTemplateResponse;
export const deleteContractTemplateResponse = (store: any) => store && store.ContractTemplate && store.ContractTemplate.deleteContractTemplateResponse;
